<template>
  <div class="container">
    <h2>{{ title }}</h2>
    <div>
      <b-table
        ref="aclTable"
        small
        sticky-header
        selectable
        select-mode="single"
        striped
        hover
        :fields="fields"
        :items="aclItems"
        primary-key="id"
        selected-variant="primary"
        @row-selected="onRowSelected"
      >
        <!-- :busy="isBusy" -->
        <!-- <template slot="[ip]" slot-scope="data"> -->
        <template v-slot:cell(ip)="data">
          <template v-if="!data.rowSelected">
            {{ data.item.ip }}
          </template>
          <template v-else>
            <b-form-input v-model="form.ip" />
          </template>
        </template>
        <template v-slot:cell(subnet)="data">
          <template v-if="!data.rowSelected">
            {{ data.item.subnet }}
          </template>
          <template v-else>
            <b-form-select v-model="form.subnet" :options="subnets" />
          </template>
        </template>
        <template v-slot:cell(comment)="data">
          <template v-if="!data.rowSelected">
            {{ data.item.comment }}
          </template>
          <template v-else>
            <b-form-input v-model="form.comment" />
          </template>
        </template>
        <template v-slot:cell(negated)="data">
          <template v-if="!data.rowSelected">
            {{ data.item.negated }}
          </template>
          <template v-else>
            <b-form-checkbox v-model="form.negated" />
          </template>
        </template>
        <template v-slot:cell(delete)="data">
          <template v-if="!data.rowSelected">
            <b-button
              v-b-tooltip.hover
              size="sm"
              variant="danger"
              title="Delete this entry"
              @click="deleteItem(data.item)"
            >
              &times;
            </b-button>
            <!-- <b-button size="sm" @click="data.toggleDetails">
              {{ data._showDetails ? '&uarr;' : '&darr;' }}
            </b-button> -->
          </template>
          <template v-else>
            <b-button-group>
              <b-button
                size="sm"
                variant="primary"
                :disabled="!formIsValid"
                @click="saveItem(data)"
              >
                Save
              </b-button>
              <b-button size="sm" @click="closeWithoutSaving">
                Close
              </b-button>
              <!-- {{ data }} -->
            </b-button-group>
          </template>
        </template>
        <template v-slot:cell(row-details)="data">
          <b-card-group>
            <b-card title="Created">
              <b-card-text>{{ data.item.created_at }}</b-card-text>
            </b-card>
            <b-card title="Updated">
              <b-card-text>{{ data.item.updated_at }}</b-card-text>
            </b-card>
          </b-card-group>
        </template>
        <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </b-table>
    </div>
    <b-button-group>
      <b-button variant="success" :disabled="!isModified" @click="saveChanges">Apply</b-button>
      <!-- <b-button @click="fetchAclData">Load</b-button> -->
      <b-button @click="addNewRow">Add</b-button>
    </b-button-group>
    <pre>
    {{ changes }}
    </pre>
  </div>
</template>

<style lang="scss" scoped>
.btn.btn-danger.btn-sm {
  margin-right: 3px;
}
</style>

<script>
import _ from 'lodash';
// import Acl from '../models/acl';
/*
function isValidValue(value) {
  if (value.length > 0) {
    const regex = /^[/\-_0-9a-zA-Z]*$/gm;
    const m = regex.exec(value);
    return !_.isNull(m) && m.length > 0;
  }
  return false;
}
*/
export default {
  name: 'AclTable',
  props: {
    items: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      addingNew: false,
      // isBusy: false,
      loaded: false,
      fields: [
        { key: 'ip', label: 'IP', sortable: true },
        { key: 'subnet', label: 'Subnet', sortable: false },
        { key: 'comment', label: 'Comment', sortable: false },
        { key: 'negated', label: 'Negated', sortable: false },
        { key: 'delete', label: '' },
      ],
      form: {
        ip: '',
        subnet: '',
        comment: '',
        negated: false,
      },
      changes: {},
    };
  },
  computed: {
    subnets() {
      const subnets = _.map(_.range(32, 7), num => {
        return { value: num, text: `/${num}` };
      });
      subnets.unshift({ value: '', text: '' });
      return subnets;
    },
    /**
     * Has the acl changed since we loaded it?
     * @returns bool
     */
    isModified() {
      const vm = this;
      if (!vm.changes) {
        return false;
      }
      return vm.changes.length > 0;
    },
    /**
     * Should the add new row button be shown?
     * @returns bool
     */
    addNewRowVisible() {
      const vm = this;
      if (!vm.loaded) {
        return false;
      }
      return vm.$refs.aclTable.selectedRows.length < 1;
    },
    /**
     * Is the source input valid?
     * @returns bool
     */
    validSource() {
      return true; // isValidValue(this.form.source);
    },
    /**
     * Is the destination input valid?
     * @returns bool
     */
    validDestination() {
      return true; // isValidValue(this.form.destination);
    },
    /**
     * Is the form valid?
     * @returns bool
     */
    formIsValid() {
      return this.validSource && this.validDestination;
    },
    /**
     * Return an array of acl items to display
     * @todo rename to something more generic.
     * @returns array
     */
    aclItems() {
      const vm = this;
      // const visible = _.castArray(vm.acl.visible);
      const items = _.clone(vm.items);
      _.each(vm.changes, change => {
        const index = _.findIndex(items, item => {
          return item.id === change.id;
        });
        switch (change.op) {
          case 'update':
            // modify any tweaked items
            items[index].ip = change.ip;
            items[index].subnet = change.subnet;
            items[index].comment = change.comment;
            items[index].negated = change.negated;
            break;
          case 'create':
            // append any new items
            // eslint-disable-next-line no-case-declarations
            const newItem = { ...change };
            _.unset(newItem, 'op');
            items.push(newItem);
            break;
          case 'delete':
            // remove any deleted items
            _.unset(items, index);
            break;
          default:
            break;
        }
      });
      if (vm.addingNew) {
        const emptyRow = _.reduce(
          vm.fields,
          (final, field) => {
            _.set(final, field.key, '');
            return final;
          },
          {}
        );
        items.push(emptyRow);
      }
      return items;
    },
  },
  async mounted() {
    const vm = this;
    vm.loaded = true;
    vm.changes = [];
  },
  methods: {
    /**
     * Set the state to open up a new item
     */
    addNewRow() {
      const vm = this;
      vm.addingNew = true;
      setTimeout(() => {
        // hacky way to bump us to the next tick, where our row will actually exist and we can select it
        vm.$refs.aclTable.selectRow(vm.aclItems.length - 1);
      }, 0);
    },
    /**
     * Delete a acl item by ip
     */
    deleteItem(item) {
      const vm = this;
      vm.changes.push({
        op: 'delete',
        id: item.id,
      });
    },
    /**
     * Save a new item to the acl
     */
    saveItem(rowData) {
      const vm = this;
      const negated = vm.form.negated ? '1' : '0';
      if (_.isUndefined(rowData.item.id)) {
        // vm.acl.addItem(vm.form.ip, vm.form.subnet, negated, vm.form.comment);
        vm.changes.push({
          op: 'create',
          ip: vm.form.ip,
          subnet: vm.form.subnet,
          comment: vm.form.comment,
          negated,
        });
      } else {
        // vm.acl.updateItem(rowData.item.ip, vm.form.ip, vm.form.subnet, negated, vm.form.comment);
        // get the selected index.
        // const index = _.findIndex(vm.$refs.aclTable.selectedRows, true);
        vm.changes.push({
          op: 'update',
          id: rowData.item.id,
          ip: vm.form.ip,
          subnet: vm.form.subnet,
          comment: vm.form.comment,
          negated,
        });
      }
      vm.addingNew = false;
      vm.$refs.aclTable.clearSelected();
      vm.form.ip = '';
      vm.form.subnet = '';
      vm.form.negated = '';
      vm.form.comment = '';
    },
    /**
     * Save the modifications to the acl to our API endpoint
     */
    saveChanges() {
      const vm = this;
      if (vm.changes.length > 0) {
        vm.$emit('patch', { acl: vm.changes });
      }
    },
    /**
     * Remove the selected row modifiers
     */
    closeWithoutSaving() {
      const vm = this;
      vm.addingNew = false;
      vm.$refs.aclTable.clearSelected();
    },
    /**
     * When a row is selected, set our form models, or unset them if we're adding a new item
     */
    onRowSelected(items) {
      const vm = this;
      const item = _.get(items, '0', false);
      if (item) {
        vm.form.ip = _.first(items).ip;
        vm.form.subnet = _.first(items).subnet;
        vm.form.comment = _.first(items).comment;
        vm.form.negated = _.first(items) === '1';
      } else {
        vm.form.ip = '';
        vm.form.subnet = '';
        vm.form.comment = '';
        vm.form.negated = false;
      }
    },
  },
};
</script>
